import React, { useEffect } from 'react';

function ContactForm() {

  useEffect(()=>{
    window.scrollTo({
        top:0,
        behavior:"smooth"
    })
},[])
  return (
    <div style={{ maxWidth: '400px', margin: '0 auto' }}>
        <h3 className='text-center'>Contact Me</h3>
      <form action="https://formsubmit.co/tahargriach@gmail.com" method="POST" className='mb-4 '>
        <input
          type="text"
          name="fullName"
          placeholder="Full Name"
          style={inputStyle}
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Email"
          style={inputStyle}
          required
        />

        <textarea
          name="message"
          rows="4"
          placeholder="Message"
          style={{ ...inputStyle, resize: 'vertical' }}
          required
        ></textarea>

        <button type="submit" style={buttonStyle}>Submit</button>
      </form>
      
    </div>
  );
}

const inputStyle = {
  width: '100%',
  padding: '10px',
  marginTop: '5px',
  marginBottom: '10px',
  border: '1px solid #ccc',
  borderRadius: '4px',
  boxSizing: 'border-box',
};

const buttonStyle = {
  backgroundColor: '#4CAF50',
  color: 'white',
  padding: '12px 20px',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  width: '100%',
};

export default ContactForm;